/*
 * @Author: chenxu chenxu@libawall.cn
 * @Date: 2023-05-29 15:34:06
 * @LastEditors: 'Lizz' lzz1961690348@163.com
 * @LastEditTime: 2023-07-06 11:12:19
 * @FilePath: \yda-qywx-h5\src\main.js
 * @Description:
 *
 */
/*
 * @Author: chenxu chenxu@libawall.cn
 * @Date: 2023-05-29 15:19:06
 * @LastEditors: chenxu chenxu@libawall.cn
 * @LastEditTime: 2023-05-29 15:28:46
 * @FilePath: \yda-qywx-h5\src\main.js
 * @Description:
 *
 */
import { htmlFontSize } from '@/utils/tool'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueCookies from 'vue-cookies'
import VConsole from 'vconsole'
import 'amfe-flexible/index.js'
import App from './App.vue'
import router from './router'
import './global.less' // 全局样式
import './assets/css/yky/index.less'
import {
  Tabbar,
  TabbarItem,
  Button,
  Space,
  ImagePreview,
  List,
  Popup,
  Field,
  Form,
  Popover,
  Cascader
} from 'vant'
import 'vant/lib/index.css'
import './assets/css/main.less'
import './assets/css/iconfont.less'
import { checkMobile } from '@/utils/utils'
import formatSealName from '@/utils/directives/formateSealName'
// vuemap
import VueAMap, { initAMapApiLoader } from '@vuemap/vue-amap'
import '@vuemap/vue-amap/dist/style.css'
import VcEnvPlugin from './plugins/vconsoleEnvPlugin'
import CacheCleanupPlugin from './plugins/cacheCleanupPlugin'

initAMapApiLoader({
  key: '19da3567642017c4e1644b052ea555ed'
})

// new VConsole()

import './navigationGuard' // 全局路由守卫
import { setScreenBrightnessAndKeepOn } from '@/utils/attachment.js'

import { xlog } from '@/utils/xlog'
import { initEnv, updateH5Version } from '@/utils/env'
import { xda, isSupport } from '@hybird/flutter'
import NoSleep from "nosleep.js";
import { Toast } from "vant";

// new VConsole();
Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0 });

let getItem = localStorage.getItem.bind(localStorage)
let setItem = localStorage.setItem.bind(localStorage)
let removeItem = localStorage.removeItem.bind(localStorage)
localStorage.getItem = (key) => {
  const r = getItem(key)
  console.log('getItem', key, r)
  return r
}

localStorage.setItem = (key, value) => {
  setItem(key, value)
  console.log('setItem', key, value)
}

localStorage.removeItem = (key) => {
  removeItem(key)
  console.log('removeItem', key)
}



// 手势暗门：右下角 7 次快速点按，切换本地 vconsole 开关
function bindGestureToggle() {
  let tapCount = 0
  let timer = null
  const reset = () => { tapCount = 0 }
  document.body.addEventListener('touchstart', (e) => {
    const t = e.touches && e.touches[0]
    if (!t) return
    const nearRightBottom = t.clientX < 80 && t.clientY > window.innerHeight - 80
    if (!nearRightBottom) return
    tapCount++
    clearTimeout(timer)
    timer = setTimeout(reset, 800)
    if (tapCount >= 7) {
      const on = localStorage.getItem('vconsole') === '1'
      localStorage.setItem('vconsole', on ? '0' : '1')
      location.reload()
    }
  }, { passive: true })
}


const app = createApp(App)
console.log = console.info;

// console.warn(import.meta.env, '------------哈哈哈')
const mode = import.meta.env.MODE;
// 触发条件：开发模式默认开启；生产/私有模式下，满足localStorage / 环境变量
const byLS = localStorage.getItem('vconsole') === '1'
const byEnv = process.env.newConnect == 1
const isProdLike = (mode === 'production' || mode === 'private')
const shouldEnableVConsole = !isProdLike || (byLS || byEnv)

if (isProdLike) {
  // 异常上报
  xlog(app, { level: 'ERROR', version: '3.1.3' })
}
if (shouldEnableVConsole) {
  const vconsole = new VConsole({
    defaultPlugins: ['system', 'network', 'storage'],
  })
  try {
    // 注册自定义环境信息插件
    vconsole.addPlugin(new VcEnvPlugin())
  } catch (e) {
    console.info('[H5] vconsole plugin 注册失败', e)
  }
}
// xlog(app, { level: 'ERROR', version: '2.6.7' })

// window.onbeforeunload = function (e) {
//   e = window.event || e
//   console.log(e)
//   if ((e.clientX > document.body.clientWidth && e.clientY < 0) || e.altKey) {
//     console.log('你关闭了浏览器')
//     // logPost({ info: { text: '你关闭了浏览器', env: 'uat' } })
//   } else {
//     console.log('你正在刷新页面')
//     // logPost({ info: { text: '你正在刷新页面', env: 'uat' } })
//   }
//   e.returnValue = '是否确定关闭页面'
// }
const u = navigator.userAgent
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

if (isiOS) {
  window.addEventListener('focusin', () => {
    setTimeout(() => {
      console.log('focus', window.scrollY)
      if (window.scrollY < 0) {
        window.scrollTo(0, 0)
      }
    }, 100)
  })
}

// 主动上报
// logPost({ level: 'DEBUG', version: '2.2.1', info: {} })
app.config.globalProperties.$cookies = VueCookies

app.use(Tabbar)
app.use(TabbarItem)
app.use(Button)
app.use(Space)
app.use(List)
app.use(Form)
app.use(Field)
app.use(Popup)
app.use(ImagePreview)
app.use(Cascader)
app.use(CacheCleanupPlugin)
app.use(createPinia())
app.use(VueAMap)
app.directive('format-sealName', formatSealName)
app.use(Popover)

const init = () => {
  initEnv().finally(() => {
    app.use(router)
    localStorage.getItem('userInfo') && checkMobile()
    setScreenBrightnessAndKeepOn()
    updateH5Version()
    app.mount('#app')

    // 绑定手势暗门
    bindGestureToggle()

    // 监听窗口宽度变化，当宽度大于900px时设置html字体大小
    const handleResize = () => {
      console.log(document.documentElement.clientWidth)
      const htmlElement = document.documentElement
      let px = htmlFontSize()
      px = px + 'px'
      htmlElement.style.fontSize = px
      htmlElement.style.setProperty('font-size', px, 'important')
    }

    // 初始检查
    handleResize()

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize)
  })
}

if (isSupport()) {
  xda.ready(() => {
    init()
  })
} else {
  init()
}
